"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e={exports:{}};exports.String_prototype=e;
